import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.497 20.157h15.006a1.32 1.32 0 0 0 1.32-1.32v-6.742a1.32 1.32 0 0 0-1.32-1.32H4.497a1.32 1.32 0 0 0-1.32 1.32v6.742c0 .729.59 1.32 1.32 1.32m0 1.2a2.52 2.52 0 0 1-2.52-2.52v-6.742a2.52 2.52 0 0 1 2.52-2.52h15.006a2.52 2.52 0 0 1 2.52 2.52v6.742a2.52 2.52 0 0 1-2.52 2.52z" }, null, -1),
    _createElementVNode("path", { d: "m20.484 21.159.801-.54.54-.802.198-.98V8.725l-.198-.98-.54-.802-.8-.54-.982-.198h-.932l.33 1.2h.602l.514.104.42.283.282.42.104.513v10.112l-.104.513-.282.42-.42.283-.514.104H4.497l-.514-.104-.42-.283-.283-.42-.103-.513V8.725l.103-.514.283-.42.42-.282.514-.104h2.966l.25-1.2H4.498l-.981.198-.801.54-.54.801-.198.981v10.112l.198.98.54.802.8.54.982.198h15.006Z" }, null, -1),
    _createElementVNode("path", { d: "m18.83 7.567.16-.696-.113-.681-.358-.592-.574-.424L11.3 2.063l-.695-.169-.68.11-.588.36-.418.58-3.191 7.072h1.316l2.968-6.578.329-.309.45.02 6.644 3.112.315.345-.015.468-1.327 2.942h.952l.334.067Z" }, null, -1),
    _createElementVNode("path", { d: "m12.63 3.126-.875-.395-3.286 7.285h1.053Z" }, null, -1)
  ]))]))
}
export default { render: render }